import lodash from 'lodash';
const { omit } = lodash;
import notHandledHere from './notHandledHere';
import { metadata, ObjectId } from 'lib_ui-services';

export default {
    verb: 'doingNew',
    description: 'New a record from a previously existing record of the same namespace/relation.',
    priority: 0,
    excludedNamespaceRelations: notHandledHere,
    //this is the actual logic:
    logic: doingNew
};
// new is a reserved word
function doingNew({ data, context }) {
    const { namespace, relation, type } = context;
    // Destructure record out to prevent it from being spread back via restOfData
    // (which would overwrite the newly created record if record was undefined in the input)
    // eslint-disable-next-line no-unused-vars
    const { newRecord, record: _ignoredRecord, ...restOfData } = data;
    const keysToOmit = metadata.commonKeysToOmit;
    // Allow a 'newRecord' property to be passed in with preset values.  This happens before
    // form state is created so this will not set the record to dirty.
    const record = { _id: new ObjectId().toString(), ...omit(newRecord, keysToOmit) };
    // A MenuItem may request that this "new" form render in a *dedicated* detail pane rather
    // than the grid's default one, by carrying a `new…`-prefixed subtype (which arrives here
    // as context.type, e.g. 'newAutoSerial'). SummaryDetailLayout selects detail panes by
    // `showForAction === activationVerb`, so echoing that variant back as the activationVerb
    // lets a single grid host several mutually-exclusive create forms (e.g. Serialized-Each's
    // "Create With Auto Serialization" / "Create From RFID Tag") without them co-mounting on a
    // plain "New" click. The variant is intentionally NOT propagated back onto the active
    // record's `type` — otherwise the next MenuItem (which inherits activeRecord.type as its
    // fallback) would re-trigger this pane. Any other `type` (e.g. 'singleRecordForm') keeps
    // the default `new` behavior.
    const isNewVariant = typeof type === 'string' && type !== 'new' && type.startsWith('new');
    return {
        activationVerb: isNewVariant ? type : 'new',
        record,
        namespace,
        relation,
        type: isNewVariant ? undefined : type,
        isNew: true,
        //I don't think this will break anything.
        //However, If data being passed through breaks things, the one property we know we need is `createdBySearch`
        ...restOfData
    };
}
